import { TIMEOUT } from '../../config/designSystem/Colors';
import { useStores } from '../useStores';

type ContentConfig = {
  contentId: string;
  type: 'CONTENT' | 'SURVEY' | 'QUESTION' | 'EXERCISE' | 'CHALLENGE';
};

export const useFetchedContentArray = (configs: ContentConfig[]) => {
  const rootStore = useStores();

  const fetchOneContent = async (config: ContentConfig) => {
    if (!config.contentId) return;

    switch (config.type) {
    case 'CONTENT':
      await rootStore?.content.fetchContentIfNotExist(config.contentId);
      setTimeout(() => rootStore?.content.setError(config.contentId), TIMEOUT);
      break;
    case 'SURVEY':
      await rootStore?.survey.fetchSurveyIfNotExist(config.contentId, true);
      setTimeout(() => rootStore?.survey.setFetchError(config.contentId, 'Timeout.'), TIMEOUT);
      break;
    case 'QUESTION':
      await rootStore?.question.fetchQuestionIfNotExist(config.contentId);
      setTimeout(() => rootStore?.question.setError(config.contentId), TIMEOUT);
      break;
    case 'EXERCISE':
      await rootStore?.exercise.fetchExerciseIfNotExist(config.contentId);
      setTimeout(() => rootStore?.exercise.setError(config.contentId), TIMEOUT);
      break;
    }
  };

  const fetch = async () => {
    await Promise.all(configs.map(fetchOneContent));
  };

  // Check loading and error status
  const isLoading = configs.some(config => {
    const store = config.type === 'CONTENT' ? rootStore?.content :
      config.type === 'SURVEY' ? rootStore?.survey :
        config.type === 'QUESTION' ? rootStore?.question :
          rootStore?.exercise;
    return !store?.isReady(config.contentId);
  });

  const error = configs.some(config => {
    const store = config.type === 'CONTENT' ? rootStore?.content :
      config.type === 'SURVEY' ? rootStore?.survey :
        config.type === 'QUESTION' ? rootStore?.question :
          rootStore?.exercise;
    return store?.hasError(config.contentId);
  });

  return { isLoading, error, fetch };
};
